import { useState, useCallback } from 'react';
import { UseModalReturn } from '@/types/modal';

export const useModal = (initialState: boolean = false): UseModalReturn => {
  const [isOpen, setIsOpen] = useState(initialState);
  const [modalTitle, setModalTitle] = useState<string>('');

  const openModal = useCallback((title?: string) => {
    if (title) {
      setModalTitle(title);
    }
    setIsOpen(true);
  }, []);

  const closeModal = useCallback(() => {
    setIsOpen(false);
  }, []);

  const toggleModal = useCallback(() => {
    setIsOpen(prev => !prev);
  }, []);

  return {
    isOpen,
    openModal,
    closeModal,
    toggleModal,
    modalTitle,
    setModalTitle,
  };
};

export default useModal;
